import { AddIcon, MinusIcon } from 'foundations-assets';
import { Spacer } from 'foundations-components/components/Spacer';
import { AccordionTransition } from 'foundations-components/transitional/components/AccordionTransition';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styled from 'foundations-theming/utils';
import { useState } from 'react';
import { useAppSelector } from '../../../reducers';
import { planBuilderProductConfigurationsSelector } from '../../../selectors/PlanBuilderSelectors';
import { skuIdIsAddonOrServiceSelector } from '../../../selectors/ProductsSelectors';
import { StyledTitleContainer } from '../SharedComponents';
import ExpandableChecklistItem from './ExpandableChecklistItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TextContainer = styled.div.withConfig({
  displayName: "ExpandableChecklist__TextContainer",
  componentId: "xi88md-0"
})(["inline-size:100%;&:hover{cursor:pointer;}"]);
const ExpandableChecklist = ({
  title,
  subtext,
  skuIds = [],
  onSelectedChange,
  use,
  defaultOpen,
  trackAccordionInteraction
}) => {
  const productConfigurations = useAppSelector(planBuilderProductConfigurationsSelector);
  const hasSelectedMerch = useAppSelector(state => productConfigurations.filter(({
    skuId
  }) => skuIdIsAddonOrServiceSelector(state, {
    skuId
  })).length > 0);
  const [isOpen, setIsOpen] = useState(defaultOpen || hasSelectedMerch);
  const toggleAccordion = () => {
    const newAccordionState = !isOpen;
    setIsOpen(newAccordionState);
    trackAccordionInteraction(use, newAccordionState);
  };
  const ChecklistTitle = /*#__PURE__*/_jsxs(TextContainer, {
    onClick: toggleAccordion,
    "data-selenium-id": `plan-builder-${use}-checklist-toggle`,
    children: [/*#__PURE__*/_jsxs(TFlex, {
      direction: "row",
      justify: "between",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(StyledTitleContainer, {
        children: title
      }), /*#__PURE__*/_jsx(IconHolder, {
        icon: isOpen ? MinusIcon : AddIcon,
        size: "800",
        marginBlockEnd: "200",
        padding: "0",
        color: "icon-interactive-default"
      })]
    }), subtext]
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(CardWrapper, {
      maxInlineSize: "700px",
      children: [/*#__PURE__*/_jsx(CardSection, {
        padding: "1000",
        paddingBlockEnd: isOpen ? '0 !important' : undefined,
        children: ChecklistTitle
      }), /*#__PURE__*/_jsxs(AccordionTransition, {
        open: isOpen,
        "data-selenium-id": `plan-builder-${use}-checklist`,
        children: [skuIds.map(skuId => {
          const selectedProductConfiguration = productConfigurations.find(({
            skuId: searchSkuId
          }) => searchSkuId === skuId);
          return /*#__PURE__*/_jsx(CardSection, {
            paddingBlockEnd: "300",
            children: /*#__PURE__*/_jsx(ExpandableChecklistItem, {
              skuId: skuId,
              selectedQuantity: selectedProductConfiguration && selectedProductConfiguration.quantity || 0,
              onSelectedChange: onSelectedChange,
              use: use
            })
          }, skuId);
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "1000"
        })]
      })]
    })
  });
};
export default ExpandableChecklist;